import axios from "axios";
import { attachAuthRefresh } from "../utils/tokenRefresh";

const KUNDLI_BASE = process.env.REACT_APP_API_BASE_URL || "";
const ASTROLOGER_BASE = KUNDLI_BASE.replace(/\/api\/kundli\/?$/, "/api/astrologers");

export const astrologerApi = axios.create({
  baseURL: ASTROLOGER_BASE,
  headers: { "Content-Type": "application/json" },
});

astrologerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("kc_access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

attachAuthRefresh(astrologerApi);

const unwrap = (promise) =>
  promise
    .then((res) => res.data)
    .catch((err) => {
      const body = err.response?.data;
      const message = body?.message || body?.detail || "Something went wrong.";
      throw { message, errors: body?.errors, status: err.response?.status };
    });

// GET /api/astrologers/ -> list of astrologers
export const listAstrologers = () => unwrap(astrologerApi.get("/"));

// POST /api/astrologers/<uuid:pk>/book/ -> book a slot
// payload: { scheduled_at, duration_minutes }
export const bookAstrologer = (astrologerId, payload) =>
  unwrap(astrologerApi.post(`/${astrologerId}/book/`, payload));

// GET /api/astrologers/bookings/ -> list of client bookings
export const getAstrologerBookings = () => unwrap(astrologerApi.get("/bookings/"));

// GET /api/astrologers/bookings/<uuid:pk>/ -> single booking detail
export const getAstrologerBookingDetail = (bookingId) =>
  unwrap(astrologerApi.get(`/bookings/${bookingId}/`));

// GET /api/astrologers/my-schedule/ -> astrologer's own schedule
export const getAstrologerSchedule = () => unwrap(astrologerApi.get("/my-schedule/"));

// GET /api/astrologers/bookings/<uuid:pk>/join/ -> join booking video room
export const joinAstrologerBooking = (bookingId) =>
  unwrap(astrologerApi.get(`/bookings/${bookingId}/join/`));

// POST /api/astrologers/bookings/<uuid:pk>/end/ -> end consultation session
export const endAstrologerBooking = (bookingId) =>
  unwrap(astrologerApi.post(`/bookings/${bookingId}/end/`));
